import type { PagedRequestDto } from '../pagination/models';

export interface VendorDto {
  id: number;
  name: string;
  code: string;
  placeId: number;
  placeName?: string;
}

export interface VendorGridItemDto {
  id: number;
  code: string;
  name: string;
  placeName: string;
}

export interface VendorInputDto {
  id?: number;
  name: string;
  code: string;
  placeId: number;
  placeName?: string;
}

export interface VendorPagedRequestDto extends PagedRequestDto {
  name?: string;
}
